if(!customElements.get('kulak-soft-carousel')){
 customElements.define('kulak-soft-carousel',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.slides=Array.from(this.querySelectorAll('[data-slide]'));this.current=0;
   this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
   document.addEventListener('visibilitychange',()=>this.sync(),{signal});
   this.motion.addEventListener('change',()=>this.sync(),{signal});
   this.go(0);
  }
  go(index){
   this.current=(index+this.slides.length)%this.slides.length;
   this.slides.forEach((slide,i)=>{const active=i===this.current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active))});
   this.sync();
  }
  sync(){
   window.clearTimeout(this.timer);
   if(this.slides.length>1&&!document.hidden)this.timer=window.setTimeout(()=>this.go(this.current+1),Number(this.dataset.interval)||6000);
  }
  disconnectedCallback(){window.clearTimeout(this.timer);this.abort?.abort()}
 });
}
